var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('segment-control',{staticClass:"lang-selector",attrs:{"segmentData":_vm.segmentData,"markColor":'rgba(165, 40, 40, .5)'},on:{"select":_vm.select}})}
var staticRenderFns = []

export { render, staticRenderFns }